import { render, staticRenderFns } from "./PEFamilies.vue?vue&type=template&id=2096c470&scoped=true&"
import script from "./PEFamilies.vue?vue&type=script&lang=js&"
export * from "./PEFamilies.vue?vue&type=script&lang=js&"
import style0 from "./PEFamilies.vue?vue&type=style&index=0&id=2096c470&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2096c470",
  null
  
)

export default component.exports